import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Chip from "@material-ui/core/Chip";
import toastError from "../../errors/toastError";
import api from "../../services/api";
import { i18n } from "../../translate/i18n";

const useStyles = makeStyles(theme => ({
	formControl: {
		"& .MuiOutlinedInput-root": {
			maxHeight: 40,
			overflow: "hidden",
		},
		"& .MuiSelect-select": {
			display: "flex",
			alignItems: "center",
			overflow: "hidden",
			paddingTop: 8,
			paddingBottom: 8,
		},
	},
	chips: {
		display: "flex",
		flexWrap: "nowrap",
		overflow: "hidden",
		alignItems: "center",
		maxWidth: "100%",
	},
	chip: {
		margin: "0 2px 0 0",
		height: 20,
		maxWidth: "100%",
	},
	limitTag: {
		height: 20,
		fontSize: "0.62rem",
		backgroundColor: "rgba(0,0,0,0.08)",
		margin: 0,
	},
}));

const QueueSelectCustom = ({ selectedQueueIds, onChange }) => {
	const classes = useStyles();
	const [queues, setQueues] = useState([]);

	useEffect(() => {
		(async () => {
			try {
				const { data } = await api.get("/queue");
				setQueues(data);
			} catch (err) {
				toastError(err);
			}
		})();
	}, []);

	const handleChange = e => {
		onChange(e.target.value);
	};

	const renderSelectedValue = selected => {
		if (!selected?.length) return null;

		if (selected.length === 1) {
			const id = selected[0];
			if (id === "0" || id === 0) {
				return (
					<div className={classes.chips}>
						<Chip
							size="small"
							label={i18n.t("queueSelect.withoutQueue")}
							className={classes.chip}
						/>
					</div>
				);
			}
			const queue = queues.find(q => q.id === id || String(q.id) === String(id));
			return (
				<div className={classes.chips}>
					<Chip
						size="small"
						style={{ backgroundColor: queue?.color }}
						variant="outlined"
						label={queue?.name || id}
						className={classes.chip}
					/>
				</div>
			);
		}

		return (
			<div className={classes.chips}>
				<Chip
					size="small"
					className={classes.limitTag}
					label={`${selected.length} filas`}
				/>
			</div>
		);
	};

	return (
		<div style={{ marginTop: 6 }}>
			<FormControl fullWidth margin="dense" variant="outlined" className={classes.formControl}>
				<InputLabel>{i18n.t("queueSelect.inputLabel")}</InputLabel>
				<Select
					multiple
					labelWidth={60}
					value={selectedQueueIds}
					onChange={handleChange}
					MenuProps={{
						anchorOrigin: {
							vertical: "bottom",
							horizontal: "left",
						},
						transformOrigin: {
							vertical: "top",
							horizontal: "left",
						},
						getContentAnchorEl: null,
					}}
					renderValue={renderSelectedValue}
				>
					<MenuItem value="0">
						{i18n.t("queueSelect.withoutQueue")}
					</MenuItem>
					{queues.map(queue => (
						<MenuItem key={queue.id} value={queue.id}>
							{queue.name}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</div>
	);
};

export default QueueSelectCustom;
